<template>
  <section class="hero">
    <div class="container">
      <div class="hero-container">
        <div class="content">
          <div>
            <p class="hi-text">Hi There ,</p>
            <h1>I am <span>Shahab Malik</span></h1>
          </div>
          <p class="detail">
            I am a web developer. I can put your imagination into technology. I
            will be your creative web development partner.
          </p>
          <button class="btn-primary"><a href="https://drive.google.com/file/d/1-VQd-uDxPIF4MKNSat3TTaSIRHzqbEMc/view?usp=sharing" target="_blank">Download CV</a></button>
        </div>
        <div class="hero-picture fade-in-fwd">
          <img src="../../assets/imgs/hero.jpg" alt="Shahab Malik" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {};
</script>

<style scoped>
  .hero {
    padding-top: 50px;
    background: #f5f5f5;
    color: var(--color-primary);
    height: 90vh;
  }
  .hero-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content {
    flex-basis: 50%;
  }
  .content .hi-text {
    font-size: 1.1em;
    font-weight: 700;
    margin-bottom: 15px;
    border-bottom: 1px solid var(--color-tertiary);
    width: 75px;
  }
  .content h1 {
    font-size: 4.5em;
    color: var(--color-secondary);
    font-family: "Raleway", sans-serif;
  }
  .content h1 span {
    color: var(--color-green);
  }

  .content .detail {
    margin-top: 50px;
    width: 90%;
    font-size: 1.2em;
    line-height: 175%;
  }
  .hero-picture img {
    width: 100%;
    height: 350px;
    border-radius: 10px;
  }
  .btn-primary a{
    text-decoration: none;
    color: var(--color-green);
  }
  .btn-primary:hover a{
    color:white;
  }

  @media only screen and (max-width: 1200px) {
    .hero-container {
      flex: 70% 30%;
    }
    .content {
      flex-basis: 70%;
    }
    .content .detail {
      margin-top: 50px;
      width: 70%;
    }
  }
  @media only screen and (min-width: 1440px) {
    .hero {
      height: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    .hero {
      height: 100%;
    }
    .content {
      flex-basis: 90%;
    }
    .hero-picture img {
      display: none;
    }
    .hero-container {
      justify-content: center;
    }

    .content h1 {
      font-size: 4em;
    }
    .content .detail {
      margin-top: 30px;
      width: 90%;
      line-height: 160%;
    }
    .btn-primary {
      justify-self: center;
    }
  }

  @media only screen and (max-width: 480px) {
    .hero {
      height: 100%;
    }
    .content {
      flex-basis: 100%;
    }
    .hero-picture img {
      display: none;
    }
    .hero-container {
      justify-content: center;
    }

    .content h1 {
      font-size: 4em;
    }
    .content .detail {
      margin-top: 30px;
      width: 90%;
    }
    .btn-primary {
      justify-self: center;
    }
    .content .hi-text {
      font-size: 1em;
      width: max-content;
    }
    .content h1 {
      font-size: 3em;
    }
    .content .detail {
      margin-top: 20px;
      width: 100%;
      font-size: 1.2em;
      line-height: 160%;
    }
  }
  .fade-in-fwd {
    -webkit-animation: fade-in-fwd 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    animation: fade-in-fwd 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  }

  @-webkit-keyframes fade-in-fwd {
    0% {
      -webkit-transform: translateZ(-80px);
      transform: translateZ(-80px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      opacity: 1;
    }
  }
  @keyframes fade-in-fwd {
    0% {
      -webkit-transform: translateZ(-80px);
      transform: translateZ(-80px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      opacity: 1;
    }
  }
</style>
